import type { NodeDefault } from '../../types';
import type { StartNodeType } from './types';
import { BlockEnum } from '../../types';
import {
  ALL_CHAT_AVAILABLE_BLOCKS,
  ALL_COMPLETION_AVAILABLE_BLOCKS,
} from '../../blocks';

const nodeDefault: NodeDefault<StartNodeType> = {
  defaultValue: {
    // variables: [],
  },
  getAvailablePrevNodes() {
    return [];
  },
  getAvailableNextNodes(isChatMode: boolean = false) {


    return ALL_COMPLETION_AVAILABLE_BLOCKS.filter(
        (type) => (type !== BlockEnum.Mirror),
      );
  },
  checkValid() {
    return {
      isValid: true,
    };
  },
};

export default nodeDefault;
